// Files under public/data, fetched once per page and shared by every layer that reads them.
const requests = new Map();

export function fetchStaticJson(url) {
  if (!requests.has(url)) {
    requests.set(url, fetch(url)
      .then((r) => {
        if (!r.ok) throw new Error(`${url}: HTTP ${r.status}`);
        return r.json();
      })
      .catch((err) => {
        requests.delete(url); // the next request tries again
        throw err;
      }));
  }
  return requests.get(url);
}
